import MicroModal from 'micromodal';

export default {
  init() {
    // JavaScript to be fired on the home page
    MicroModal.init({
      awaitCloseAnimation: true,
      disableScroll: true,
    });

    $('.button--request').on('click', function() {
      $('.modal .wpcf7-hidden[name="to_email"]').attr('value', $(this).data('email'));
      MicroModal.show('modal-2', {
        awaitCloseAnimation: true,
        disableScroll: true,
      });
    });


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateInfo.js